// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeartSelected: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="14"
            height="13"
            fill="currentColor"
        >
            <path
                d="M929.635547,625.468828 C928.998437,624.89625 928.180859,624.600391 927.355078,624.625 C926.329962,624.625 925.295273,625.046094 924.538672,625.827578 L924,626.381836 L923.461328,625.827578 C922.703906,625.046094 921.670313,624.625 920.644922,624.625 C919.81914,624.625 919.002383,624.896523 918.340937,625.468828 C916.641797,626.939648 916.556758,629.562187 918.088555,631.145391 L923.371367,636.605938 C923.546094,636.784766 923.770313,636.875 923.997265,636.875 C924.225094,636.875 924.453633,636.785668 924.626445,636.606922 L929.906524,631.146376 C931.442969,629.560547 931.358202,626.938281 929.635547,625.468828 Z"
                transform="translate(-917 -624)"
            />
        </svg>
    );
};

export default React.memo(HeartSelected);
